import 'angular';

import './jobs/transaction-center.jobs.module.ajs';

angular.module('app-lite.transaction-center', [
  'app-lite.transaction-center.jobs'
]);
